module.exports = __webpack_public_path__ + "static/media/screenshot 5.39dd60e1.jpg";